
import VueRouter from 'vue-router';
import routes from './customers-routes';
import { CUSTOMERS_ROOT_PATH } from './config';

export default new VueRouter({ routes, mode: 'history', base: CUSTOMERS_ROOT_PATH });
